import React, { useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileStickyBar } from './MobileStickyBar';
import { useLocation } from 'react-router-dom';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen bg-brand-offwhite flex flex-col" data-id="element-100">
      <Header data-id="element-101" />
      <main className="flex-grow pt-20 lg:pt-24" data-id="element-102">{children}</main>
      <Footer data-id="element-103" />
      <MobileStickyBar data-id="element-104" />
    </div>;
}